export default "__VITE_ASSET__DboC6LsH__"